export default "__VITE_ASSET__45485ca0__"